import './FindId.scss';
import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaArrowLeft, FaCheck } from 'react-icons/fa';
import fnc from '../mymod/commFunction';

const VERIFY_SECONDS = 5 * 60;

function FindId() {
const navigate = useNavigate();
const [hp, setHp] = useState('');
const [verifyCode, setVerifyCode] = useState('');
const [codeSent, setCodeSent] = useState(false);
const [foundId, setFoundId] = useState('');
const [timeLeft, setTimeLeft] = useState(0);
const timerRef = useRef(null);

useEffect(() => () => clearInterval(timerRef.current), []);

function startTimer() {
    clearInterval(timerRef.current);
    setTimeLeft(VERIFY_SECONDS);
    timerRef.current = setInterval(() => {
    setTimeLeft((prev) => {
        if (prev <= 1) { clearInterval(timerRef.current); return 0; }
        return prev - 1;
    });
    }, 1000);
}

function formatTime(sec) {
    const m = String(Math.floor(sec / 60)).padStart(2, '0');
    const s = String(sec % 60).padStart(2, '0');
    return `${m}:${s}`;
}

const step = foundId ? 3 : codeSent ? 2 : 1;

function handleSendCode(e) {
    e.preventDefault();
    if (!hp.trim()) { alert('휴대폰 번호를 입력해주세요.'); return; }
    fnc.sendAxios('/findIdRoutes/sendVerifyCode', { hp: hp.trim() }, (res) => {
    if (res.error) { alert(res.message || '인증번호 전송에 실패했습니다.'); return; }
    setCodeSent(true);
    setVerifyCode('');
    setFoundId('');
    startTimer();
    });
}

function handleVerify(e) {
    e.preventDefault();
    if (!verifyCode.trim()) { alert('인증번호를 입력해주세요.'); return; }
    if (timeLeft === 0) { alert('인증번호가 만료되었습니다. 다시 요청해주세요.'); return; }
    fnc.sendAxios('/findIdRoutes/findId', { hp: hp.trim(), code: verifyCode.trim() }, (res) => {
    if (res.error) { alert(res.message || '인증 실패'); return; }
    clearInterval(timerRef.current);
    setFoundId(res.id || '');
    });
}

function handleReset() {
    clearInterval(timerRef.current);
    setHp('');
    setVerifyCode('');
    setCodeSent(false);
    setFoundId('');
    setTimeLeft(0);
}

return (
    <div className='FindId'>
    <div className='find-id-card'>
        <div className='card-header'>
        <h2 className='card-title'>아이디 찾기</h2>
        <button type='button' className='btn-back' onClick={() => navigate('/login')}>
            <FaArrowLeft /> 로그인
        </button>
        </div>

        {/* 단계 표시 */}
        <div className='step-indicator'>
        <div className={`step-dot ${step >= 1 ? 'done' : ''} ${step === 1 ? 'active' : ''}`}>
            <span>1</span><em>번호 입력</em>
        </div>
        <div className={`step-line ${step >= 2 ? 'done' : ''}`} />
        <div className={`step-dot ${step >= 2 ? 'done' : ''} ${step === 2 ? 'active' : ''}`}>
            <span>2</span><em>인증번호</em>
        </div>
        <div className={`step-line ${step >= 3 ? 'done' : ''}`} />
        <div className={`step-dot ${step >= 3 ? 'done' : ''}`}>
            <span>{step === 3 ? <FaCheck /> : '3'}</span><em>완료</em>
        </div>
        </div>

        {/* STEP 1 */}
        {step < 3 && (
        <div className='step-block'>
            <label className='field-label' htmlFor='findId-hp'>*휴대폰 번호</label>
            <form onSubmit={handleSendCode} className='field-row'>
            <input
                id='findId-hp'
                name='hp'
                type='tel'
                autoComplete='tel'
                className='field-input'
                value={hp}
                onChange={(e) => setHp(e.target.value)}
                placeholder='01012345678'
                maxLength={11}
                disabled={codeSent && timeLeft > 0}
            />
            <button
                type='submit'
                className={`btn-action ${codeSent && timeLeft > 0 ? 'sent' : ''}`}
                disabled={codeSent && timeLeft > 0}
            >
                {codeSent ? '재전송' : '전송'}
            </button>
            </form>
            {codeSent && timeLeft > 0 && (
            <p className='sent-notice'>인증번호가 발송되었습니다.</p>
            )}
        </div>
        )}

        {/* STEP 2 */}
        {codeSent && step < 3 && (
        <div className='step-block'>
            <label className='field-label' htmlFor='findId-code'>인증번호</label>
            <form onSubmit={handleVerify} className='field-row'>
            <div className='code-wrap'>
                <input
                id='findId-code'
                name='verifyCode'
                type='text'
                autoComplete='one-time-code'
                className='field-input code-input'
                value={verifyCode}
                onChange={(e) => setVerifyCode(e.target.value)}
                placeholder='6자리 입력'
                maxLength={6}
                />
                <span className={`timer-badge ${timeLeft <= 60 ? 'urgent' : ''}`}>
                {timeLeft > 0 ? formatTime(timeLeft) : '만료'}
                </span>
            </div>
            <button type='submit' className='btn-action confirm'>확인</button>
            </form>
        </div>
        )}

        {/* STEP 3 - 결과 */}
        {step === 3 && (
        <div className='result-panel'>
            <div className='result-icon'><FaCheck /></div>
            <p className='result-label'>회원님의 아이디</p>
            <div className='result-id'>{foundId}</div>
            <button type='button' className='btn-reset' onClick={handleReset}>
            다시 찾기
            </button>
            <button type='button' className='btn-to-login' onClick={() => navigate('/login')}>
            로그인으로 이동
            </button>
        </div>
        )}

        {/* 비밀번호 찾기 링크 */}
        {step === 1 && (
        <p className='sub-link'>
            <button type='button' onClick={() => navigate('/find-password')}>비밀번호도 잊으셨나요?</button>
        </p>
        )}
    </div>
    </div>
);
}

export default FindId;

